import { Try } from "@/common";
import { IdType, PageDataType } from ".";
import { Notify } from "quasar";
import { api } from "@/plugins";

export type ServiceType = {
  id: number;
  name: string;
  projectId: number;
  description: string;
  services: any;
  createdAt: string;
};

export type ServicePartialType = Partial<ServiceType>;
export type ServicePageDataType = PageDataType<ServiceType>;

const url = "service";

class ServiceService {
  @Try()
  async page(projectId: number, query: string) {
    const { data } = await api.get<ServicePageDataType>(
      `/${url}/page/${projectId}?${query}`
    );

    return data;
  }

  @Try()
  async getById(id: number) {
    const { data } = await api.get<ServiceType>(`/${url}/${id}`);

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "green",
        icon: "tag_faces",
        message: "Luck removed",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async delete(id: number) {
    await api.delete<ServiceType>(`/${url}/${id}`);
    return true;
  }

  @Try()
  async search(q: string = "") {
    const { data } = await api.get<ServiceType[]>(`/${url}/search?q=${q}`);

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "green",
        icon: "tag_faces",
        message: "Created successfully",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async create(service: ServiceType) {
    const { data } = await api.post<IdType>(`/${url}/`, service);

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "secondary",
        icon: "tag_faces",
        message: "Luck updated",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async update(id: number, service: ServicePartialType) {
    await api.patch(`/${url}/${id}`, service);
    return true;
  }
}

const serviceService = new ServiceService();

export { serviceService as ServiceService };
